export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      6294.0589569161,
    ],
    button_spin: [
      8000,
      1539.7732426303853,
    ],
    end_fs_popup: [
      11000,
      4152.018140589568,
    ],
    free_bet_big_win: [
      17000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      20000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      24000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      26000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      29000,
      50887.98185941043,
    ],
    free_spin_music: [
      81000,
      70915.19274376419,
    ],
    free_spin_popup: [
      153000,
      4195.5555555555575,
    ],
    free_spin_start: [
      159000,
      3397.369614512485,
    ],
    inside_buttons: [
      164000,
      280.0907029478594,
    ],
    main_ambient: [
      166000,
      78731.60997732427,
    ],
    main_music: [
      246000,
      164967.61904761905,
    ],
    mega_win: [
      412000,
      6720.72562358278,
    ],
    mult_idle: [
      420000,
      1592.0181405895732,
    ],
    mult_x1: [
      423000,
      2404.716553287983,
    ],
    mult_x3: [
      427000,
      2111.564625850349,
    ],
    mult_x5: [
      431000,
      2544.03628117916,
    ],
    mult_x7: [
      435000,
      2753.0158730158973,
    ],
    mult_x9: [
      439000,
      2430.8390022675894,
    ],
    outside_buttons: [
      443000,
      393.28798185943015,
    ],
    reel_spin: [
      445000,
      1875.0113378685,
    ],
    reel_stop_01: [
      448000,
      50.79365079365061,
    ],
    reel_stop_02: [
      450000,
      65.30612244898748,
    ],
    reel_stop_03: [
      452000,
      65.30612244898748,
    ],
    reel_stop_04: [
      454000,
      59.50113378685273,
    ],
    reel_stop_05: [
      456000,
      62.40362811792011,
    ],
    regular_win: [
      458000,
      1551.38321995463,
    ],
    scatter_chance: [
      461000,
      4314.557823129235,
    ],
    scatter_stop: [
      467000,
      1255.3287981859285,
    ],
    tap_to_play: [
      470000,
      2935.873015873028,
    ],
    ultra_win: [
      474000,
      6796.190476190475,
    ],
    wild_stop: [
      482000,
      1147.9365079364925,
    ],
  },
}
